import { Button, ButtonLoaderPlacement, ButtonSize, ButtonVariant } from '@farmasiet/frontendcore-reactcomponents';
import React from 'react';

export const ButtonsTest = () => {
    return (
        <div className="ButtonsTest">
            <div className="ButtonsTest--Wrapper">
                <h2>Primary buttons</h2>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Primary}>
                    Large
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Primary} loading>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Primary} loading loaderPlacement={ButtonLoaderPlacement.Right}>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Primary} disabled>
                    Disabled
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Primary}>
                    Medium
                </Button>
                <Button size={ButtonSize.Small} variant={ButtonVariant.Primary}>
                    Small
                </Button>
                <Button size={ButtonSize.XSmall} variant={ButtonVariant.Primary}>
                    XSmall
                </Button>
                <Button size={ButtonSize.XXSmall} variant={ButtonVariant.Primary}>
                    XXSmall
                </Button>
            </div>
            <div className="ButtonsTest--Wrapper">
                <h2>Phil primary buttons</h2>
                <Button size={ButtonSize.Large} variant={ButtonVariant.PhilPrimary}>
                    Large
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.PhilPrimary} loading>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.PhilPrimary} loading loaderPlacement={ButtonLoaderPlacement.Right}>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.PhilPrimary} disabled>
                    Disabled
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.PhilPrimary}>
                    Medium
                </Button>
                <Button size={ButtonSize.Small} variant={ButtonVariant.PhilPrimary}>
                    Small
                </Button>
                <Button size={ButtonSize.XSmall} variant={ButtonVariant.PhilPrimary}>
                    XSmall
                </Button>
                <Button size={ButtonSize.XXSmall} variant={ButtonVariant.PhilPrimary}>
                    XXSmall
                </Button>
            </div>
            <div className="ButtonsTest--Wrapper">
                <h2>Secondary buttons</h2>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Secondary}>
                    Large
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Secondary} loading>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Secondary} loading loaderPlacement={ButtonLoaderPlacement.Right}>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Secondary} disabled>
                    Disabled
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Secondary}>
                    Medium
                </Button>
                <Button size={ButtonSize.Small} variant={ButtonVariant.Secondary}>
                    Small
                </Button>
                <Button size={ButtonSize.XSmall} variant={ButtonVariant.Secondary}>
                    XSmall
                </Button>
                <Button size={ButtonSize.XXSmall} variant={ButtonVariant.Secondary}>
                    XXSmall
                </Button>
            </div>
            <div className="ButtonsTest--Wrapper">
                <h2>Tertiary buttons</h2>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Tertiary}>
                    Large
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Tertiary} loading>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Tertiary} loading loaderPlacement={ButtonLoaderPlacement.Right}>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Tertiary} disabled>
                    Disabled
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Tertiary}>
                    Medium
                </Button>
                <Button size={ButtonSize.Small} variant={ButtonVariant.Tertiary}>
                    Small
                </Button>
                <Button size={ButtonSize.XSmall} variant={ButtonVariant.Tertiary}>
                    XSmall
                </Button>
                <Button size={ButtonSize.XXSmall} variant={ButtonVariant.Tertiary}>
                    XXSmall
                </Button>
            </div>
            <div className="ButtonsTest--Wrapper">
                <h2>Quaternary buttons</h2>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Quaternary}>
                    Large
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Quaternary} loading>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Quaternary} loading loaderPlacement={ButtonLoaderPlacement.Right}>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Quaternary} disabled>
                    Disabled
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Quaternary}>
                    Medium
                </Button>
                <Button size={ButtonSize.Small} variant={ButtonVariant.Quaternary}>
                    Small
                </Button>
                <Button size={ButtonSize.XSmall} variant={ButtonVariant.Quaternary}>
                    XSmall
                </Button>
                <Button size={ButtonSize.XXSmall} variant={ButtonVariant.Quaternary}>
                    XXSmall
                </Button>
            </div>
            <div className="ButtonsTest--Wrapper">
                <h2>Text buttons</h2>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Text}>
                    Large
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Text} loading>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Text} loading loaderPlacement={ButtonLoaderPlacement.Right}>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Text} disabled>
                    Disabled
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Text}>
                    Medium
                </Button>
                <Button size={ButtonSize.Small} variant={ButtonVariant.Text}>
                    Small
                </Button>
                <Button size={ButtonSize.XSmall} variant={ButtonVariant.Text}>
                    XSmall
                </Button>
                <Button size={ButtonSize.XXSmall} variant={ButtonVariant.Text}>
                    XXSmall
                </Button>
            </div>
            <div className="ButtonsTest--Wrapper">
                <h2>Link buttons</h2>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Link}>
                    Large
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Link} loading>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Link} loading loaderPlacement={ButtonLoaderPlacement.Right}>
                    Loading
                </Button>
                <Button size={ButtonSize.Large} variant={ButtonVariant.Link} disabled>
                    Disabled
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Link}>
                    Medium
                </Button>
                <Button size={ButtonSize.Small} variant={ButtonVariant.Link}>
                    Small
                </Button>
                <Button size={ButtonSize.XSmall} variant={ButtonVariant.Link}>
                    XSmall
                </Button>
                <Button size={ButtonSize.XXSmall} variant={ButtonVariant.Link}>
                    XXSmall
                </Button>
            </div>
        </div>
    );
};
